import { Fragment, useEffect, useState } from "react";
import { Initialload } from "../shared/contextapi";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../shared/layouts-components/footer/footer";
import Backtotop from "../shared/layouts-components/backtotop/backtotop";
import Switcher from "../shared/layouts-components/switcher/switcher";
import Header from "../shared/layouts-components/header/header";
import Sidebar from "../shared/layouts-components/sidebar/sidebar";
import CaresAuthenticatedFooter from "../components/cares/shell/cares-authenticated-footer";
import CaresAuthenticatedHeader from "../components/cares/shell/cares-authenticated-header";
import CaresAuthenticatedSidebar from "../components/cares/shell/cares-authenticated-sidebar";
import { isCaresOwnedAuthenticatedPath } from "../components/cares/shell/route-ownership";


function App() {
  const location = useLocation();

  const [lateLoad, setlateLoad] = useState(false);

  useEffect(() => {
    setlateLoad(true);
  });
  const [pageloading, setpageloading] = useState(false)

  const [isSwitcherOpen, setSwitcherOpen] = useState(false); // State to control switcher visibility

  const toggleSwitcher = () => {
    setSwitcherOpen((prevState) => !prevState); // Toggle the switcher visibility
  };

  const shellHeader = isCaresOwnedAuthenticatedPath(location.pathname)
    ? <CaresAuthenticatedHeader />
    : <Header />;
  const shellSidebar = isCaresOwnedAuthenticatedPath(location.pathname)
    ? <CaresAuthenticatedSidebar />
    : <Sidebar />;
  const shellFooter = isCaresOwnedAuthenticatedPath(location.pathname)
    ? <CaresAuthenticatedFooter />
    : <Footer />;

  return (
    <>
      <Fragment>
        <Initialload.Provider value={{ pageloading, setpageloading }}>
          <div style={{ display: `${lateLoad ? "block" : "none"}` }}>
            <Switcher isSwitcherOpen={isSwitcherOpen} toggleSwitcher={toggleSwitcher} />
            <div className='page'>
              {shellHeader}
              {shellSidebar}
              <div className={`main-content app-content`}>
                <div className='container-fluid'>
                  <Outlet />
                </div>
              </div>
              {shellFooter}
            </div>
            <Backtotop />
          </div>
        </Initialload.Provider>
      </Fragment>
    </>
  )
}

export default App
